/*
 * Orbit Trends — Stable Film Hero
 * Poster-first, single native-looping video per panel. No JS crossfade rotation:
 * mobile browsers were flickering/stalling during swaps, so reliability wins here.
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function makePoster(clip, eager) {
    var img = document.createElement('img');
    img.src = clip.poster;
    img.alt = '';
    img.decoding = 'async';
    img.loading = eager ? 'eager' : 'lazy';
    if (eager) img.fetchPriority = 'high';
    img.className = 'orbit-film-hero__poster';
    return img;
  }

  function makeVideo(clip) {
    var video = document.createElement('video');
    video.className = 'orbit-film-hero__video orbit-film-hero__video--current';
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.autoplay = true;
    video.playsInline = true;
    video.preload = 'auto';
    video.poster = clip.poster;
    video.setAttribute('aria-hidden', 'true');
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');

    function markReady() {
      video.classList.add('is-ready');
    }
    function markUnavailable() {
      video.classList.remove('is-ready');
    }

    video.addEventListener('canplay', markReady);
    video.addEventListener('playing', markReady);
    video.addEventListener('loadeddata', markReady);
    video.addEventListener('waiting', markUnavailable);
    video.addEventListener('stalled', markUnavailable);
    video.addEventListener('error', markUnavailable);

    if (clip.webm) {
      var webm = document.createElement('source');
      webm.src = clip.webm;
      webm.type = 'video/webm';
      video.appendChild(webm);
    }

    var mp4 = document.createElement('source');
    mp4.src = clip.mp4;
    mp4.type = 'video/mp4';
    video.appendChild(mp4);

    return video;
  }

  function safePlay(video) {
    if (!video || prefersReducedMotion()) return;
    var play = video.play && video.play();
    if (play && play.catch) play.catch(function () {});
  }

  function initPanel(panel, clips, panelIndex) {
    var slot = panel.querySelector('[data-orbit-film-slot]');
    var sweep = panel.querySelector('.orbit-film-hero__sweep');
    if (!slot || !clips.length) return;

    var clip = clips[panelIndex % clips.length];
    var eager = panelIndex === 0;
    slot.textContent = '';
    slot.appendChild(makePoster(clip, eager));

    // Poster-only for panels hidden by CSS (mobile shows one panel) and on
    // Save-Data/2G — avoids downloading ~4MB of video per invisible panel.
    var conn = navigator.connection || {};
    var saveBandwidth = conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
    var panelHidden = panel.offsetWidth === 0 || panel.offsetHeight === 0;
    if (prefersReducedMotion() || panelHidden || saveBandwidth) {
      if (sweep) sweep.hidden = true;
      return;
    }

    var video = makeVideo(clip);
    slot.appendChild(video);
    safePlay(video);

    // Native loop should handle playback. This watchdog only restarts if a browser stalls.
    window.setInterval(function () {
      if (document.hidden) return;
      if (video.paused || video.ended || video.readyState < 2) safePlay(video);
    }, 4000);
  }

  function initHero(hero) {
    if (hero.dataset.orbitFilmReady === 'true') return;
    hero.dataset.orbitFilmReady = 'true';

    var source = hero.querySelector('[data-orbit-film-clips]');
    if (!source) return;

    var clips = [];
    try { clips = JSON.parse(source.textContent || '[]'); } catch (e) {}
    if (!clips.length) return;

    hero.querySelectorAll('[data-orbit-film-panel]').forEach(function (panel, index) {
      initPanel(panel, clips, index);
    });
  }

  function initAll(container) {
    (container || document).querySelectorAll('[data-orbit-film-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
